var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"preview-rich-text",attrs:{"i-class":"pa-20"}},[_c('div',{staticClass:"main-content",domProps:{"innerHTML":_vm._s(_vm.richText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }